import angular from 'angular';

import component from './globalMessageList.component';

import globalMessageService from '../../service/GlobalMessageService';
import constants from '../../constants';

let module = angular.module('recaps.components.globalMessageList', [
  globalMessageService.name,
  constants,
]);

module.component('globalMessageList', component);

export default module;
